import { Component, OnInit } from '@angular/core';

import { Constants } from '../../helper/constants';
import { ReportsService } from '../../services/reports.service';
import { LetterDashboardModel } from '../../viewmodels/letter-dashboard.model';
import { AuthenticationService } from '../../../../authentication/services/authentication.service';
import { ApplicationUser } from '../../../../authentication/viewmodels/application-user';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'letter-dashboard',
  templateUrl: './letter-dashboard.component.html',
  styleUrls: ['./letter-dashboard.component.scss'],
})
export class LetterDashboardComponent implements OnInit {
  public constants = Constants;
  public currentUser = new ApplicationUser();

  star = {
    total: 0,
    completed: 0,
    percent: 0,
  };

  letter = {
    total: 0,
    completed: 0,
    percent: 0,
  };

  letterDashboard = new LetterDashboardModel();

  constructor(
    private reportsServ: ReportsService,
    private authServ: AuthenticationService
  ) {}

  ngOnInit() {
    this.getLetterDashboard();
    this.getCurrentUser();
  }

  getCurrentUser() {
    this.currentUser = this.authServ.getCurrentUser();
  }

  getLetterDashboard() {
    this.reportsServ.getLetterDashboard().subscribe(
      (letterDashboard) => {
        this.letterDashboard = letterDashboard;
        this.setStats();
      },
      (err) => console.log(err)
    );
  }

  setStats() {
    this.star.total = parseInt(this.letterDashboard.answeredTotalTarget, 10);
    this.star.completed = parseInt(this.letterDashboard.answeredTotal, 10);
    this.star.percent = this.getPercent(this.star);

    this.letter.total = parseInt(this.letterDashboard.answeredTodayTarget, 10);
    this.letter.completed = parseInt(this.letterDashboard.answeredToday, 10);
    this.letter.percent = this.getPercent(this.letter);
  }

  getChangeArrowIcon(changeValue) {
    return (
      this.constants.assetsPath +
      '/img/icons/' +
      (parseInt(changeValue, 10) > 0 ? 'green-arrow-up.svg' : 'red-arrow-down.svg')
    );
  }

  getCircleColor() {
    if (this.letter.percent <= 25) {
      return '#ff0011';
    } else if (this.letter.percent <= 50) {
      return '#f3c619';
    } else if (this.letter.percent <= 75) {
      return '#FEF00A';
    }
    return '#0bae21';
  }

  private getPercent(items) {
    if (!items.total || items.total === 0) {
return 0;
}
    return Math.round((items.completed / items.total) * 100);
  }
}
